import React, { Component } from 'react';
import Navbar from './Navbar';
import Showcase from './Showcase';
import About from './About';
import Projects from './Projects';
import Contact from './Contact';


export default class props extends Component {
    render() {
        return (
            <div>
                <Navbar />
                <Showcase />
                <About />
                <Projects />
                <Contact />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Portfolio.js